import { FunctionComponent, useEffect, useRef, useState } from "react";
import "./Exam.scss";
import Table from "../../Components/Table/Table";
import CustomToolbar from "../../Components/Table/components/CustomToolbar";
import ButtonField from "../../Components/Button/ButtonField";
import { Columns } from "../../Components/Table/ITable";
import {
  GridRenderCellParams,
  GridValueFormatterParams,
} from "@mui/x-data-grid";
import { IExam } from "./IExam";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import Dialog from "../../Components/Dialog/Dialog";
import ExamForm from "./ExamForm";
import ResponseDialog from "../../Components/ResponseDialog/ResponseDialog";
import TableSearch from "../../Components/Table/components/TableSearch";
import { ReactComponent as Delete } from "../../Assets/Images/delete.svg";
import { ReactComponent as Edit } from "../../Assets/Images/edit.svg";
import { IDeleteDialog } from "../../Components/DeleteDialog/IDeleteDialog";
import IconButtonField from "../../Components/Button/IconButtonField";
import { SvgIcon, Tooltip } from "@mui/material";
import DeleteDialog from "../../Components/DeleteDialog/DeleteDialog";
import { ReactComponent as RefreshButton } from "../../Assets/Images/RefreshButton.svg";
import { listExam } from "../../Redux/Slices/Exam/ListExamSlice";
import { clearAddExamResponse } from "../../Redux/Slices/Exam/AddExamSlice";
import {
  clearDeleteExamResponse,
  deleteExam,
} from "../../Redux/Slices/Exam/DeleteExamSlice";
import { clearEditExamResponse } from "../../Redux/Slices/Exam/EditExamSlice";
import { listSideMenuPermission } from "../../Redux/Slices/SideMenuPermission/ListSideMenuPermissionSlice";
import { listExamModel } from "../../Redux/Slices/ExamModel/ListExamModelSlice";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { useNavigate } from "react-router-dom";
import { listYearlevel_map } from "../../Redux/Slices/Yearlevel_map/ListYearlevel_mapSlice";
import LibraryAddIcon from "@mui/icons-material/LibraryAdd";
import InstructionPageTamplete from "../PageTamplete/InstructionPageTamplete";

interface ExamProps { }

const Exam: FunctionComponent<ExamProps> = () => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState<boolean>(false);
  const [deleteDialogData, setDeleteData] = useState<IDeleteDialog>({});
  const [initialValues, setInitialValues] = useState<IExam>({});
  const [previewType, setPreviewType] = useState<string | null>(null);
  const [previewItem, setPreviewItem] = useState<any>(null);
  const dispatch = useAppDispatch();
  const { data: listExams } = useAppSelector((state) => state.ListExamSlice);
  const { data: addExam } = useAppSelector((state) => state.AddExamSlice);
  const { data: EditExam } = useAppSelector((state) => state.EditExamSlice);
  const { data: deleteExams } = useAppSelector((state) => state.DeleteExam);
  const permissions = useAppSelector((state) => state.PermissionsToPage);
  const finaldata = { permissions };

  const navigate = useNavigate();

  const formRef = useRef<HTMLFormElement>(null);
  const columns: Columns = [
    {
      field: "index",
      renderHeader: () => <b>S.No</b>,
      width: 90,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "name",
      renderHeader: () => <b>Exam</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
    },

    {
      field: "exam_model_name",
      renderHeader: () => <b>Exam Model</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
    },
    {
      field: "description",
      renderHeader: () => <b>Description</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
    },
    {
      field: "status",
      renderHeader: () => <b>Status</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      cellClassName: (params) =>
        `activename ${params.row.status ? "active" : "inactive"}`,

      valueFormatter: (params) =>
        params.value === true ? "Active" : "Inactive",
    },
    {
      field: "action",
      renderHeader: () => <b>Action</b>,
      flex: 1,
      type: "actions",
      renderCell: (params: GridRenderCellParams<IExam>) => {
        return (
          <>
            <RemoveRedEyeIcon
              titleAccess="Review Exam page"
              sx={{ cursor: "pointer" }}
              onClick={() => {
                setPreviewType("instruction");
                setPreviewItem(params.row);
              }}
            ></RemoveRedEyeIcon>

            <IconButtonField
              disabled={finaldata?.permissions?.edit === false}
              onClick={() => {
                setInitialValues({ ...params.row, id: params.id as number });
                setIsEdit(true);
                setDialogOpen(true);
              }}
            >
              <SvgIcon sx={{ fill: "none" }} component={Edit} inheritViewBox />
            </IconButtonField>
            <IconButtonField
              toolTip="Duplicate"
              disabled={finaldata?.permissions?.add === false}
              onClick={() => {
                const duplicatedRow = { ...params.row };
                delete duplicatedRow.id;
                delete (duplicatedRow as any).index;
                delete duplicatedRow.year_group_id;
                duplicatedRow.name = `${duplicatedRow.name}-1`;
                setInitialValues(duplicatedRow);
                setDialogOpen(true);
              }}
            >
              <LibraryAddIcon sx={{ fontSize: 20, color: "#4785ff" }} />
            </IconButtonField>
            <IconButtonField
              disabled={finaldata?.permissions?.delete === false}
              onClick={() => {
                setDeleteData({ id: params.id, name: params?.row?.name });
                setDeleteDialogOpen(true);
              }}
            >
              <SvgIcon component={Delete} inheritViewBox />
            </IconButtonField>
          </>
        );
      },
    },
  ];

  const Exam = Array.isArray(listExams?.data)
    ? listExams?.data.map((user, index) => ({ ...user, index: index + 1 }))
    : [];

  useEffect(() => {
    dispatch(listExam());
    dispatch(listYearlevel_map());
    dispatch(listExamModel());
    // dispatch(listSideMenuPermission());
  }, [addExam, EditExam, deleteExams, dispatch]);
  useEffect(() => {
    return () => {
      dispatch(clearAddExamResponse());
      dispatch(clearEditExamResponse());
      dispatch(clearDeleteExamResponse());
    };
  }, [dispatch]);
  return (
    <>
      <Table rows={Exam ?? []} columns={columns} exportFileName="Exams">
        <CustomToolbar>
          <h6></h6>
          <TableSearch />
          <ButtonField
            className="tabel_add_new_button"
            onClick={() => {
              setInitialValues({
                status: true,
                mock_exam: false,
                free_tier: false,
                instruction: [],
              });
              setIsEdit(false);
              setDialogOpen(true);
            }}
            toolTip="Add new"
            disabled={finaldata?.permissions?.add === false}
          >
            Add new
          </ButtonField>
          <IconButtonField
            className="refresh_btn"
            toolTip="Refresh"
            onClick={() => dispatch(listExam())}
          >
            <SvgIcon
              className="refresh_svg_icon"
              component={RefreshButton}
              inheritViewBox
            />
          </IconButtonField>
        </CustomToolbar>
      </Table>

      <Dialog
        open={dialogOpen}
        dialogClassName="dialog_double_input"
        Dialog_Title={`${isEdit ? "Update" : "Add"} Exam`}
        Dialog_Content={
          <ExamForm
            formRef={formRef}
            initialValues={initialValues}
            setInitialValues={setInitialValues}
          />
        }
        Dialog_Actions={
          <>
            <ButtonField
              className="form_cancel_button"
              onClick={() => {
                setDialogOpen(false);
                setIsEdit(false);
                setInitialValues({
                  status: true,
                  mock_exam: false,
                  free_tier: false,
                  instruction: [],
                });
              }}
            >
              Cancel
            </ButtonField>
            <ButtonField
              className="form_save_button"
              onClick={() => formRef.current?.requestSubmit()}
            >
              Save
            </ButtonField>
          </>
        }
      />
      <ResponseDialog response={addExam} parentDialog={setDialogOpen} />
      <ResponseDialog response={EditExam} parentDialog={setDialogOpen} />
      <DeleteDialog
        deleteableName={deleteDialogData.name ?? ""}
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        deleteFunction={() => {
          dispatch(deleteExam(deleteDialogData.id));
        }}
        response={deleteExams}
      />

      {previewType === "instruction" && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "#fff",
          zIndex: 2000,
          overflow: "auto"
        }}>
          <InstructionPageTamplete
            previewData={previewItem}
            onBack={() => setPreviewType(null)}
            isOverlay={true}
          />
        </div>
      )}
    </>
  );
};

export default Exam;
